import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectionService {

  private _cachedResult: boolean | null = null;

  constructor(private platform: Platform) { }

  /**
   * Detecta si debe usar la cámara nativa (capgo/CameraX) para Android 13 o menor
   * debido al bug del plugin de Capacitor Camera en esas versiones.
   * Android 14+ usa el plugin oficial de Capacitor Camera sin problemas.
   */
  async shouldUseNativeCamera(): Promise<boolean> {
    if (this._cachedResult !== null) return this._cachedResult;
    if (!this.platform.is('android')) {
      this._cachedResult = false;
      return this._cachedResult;
    }
    try {
      const info = await Device.getInfo();
      const osVersion = parseInt(info.osVersion);
      this._cachedResult = osVersion <= 13;
      return this._cachedResult;
    } catch (error) {
      console.error('Error detecting device version:', error);
      this._cachedResult = true;
      return this._cachedResult;
    }
  }

  /**
   * Obtiene información detallada del dispositivo
   */
  async getDeviceInfo() {
    if (this.platform.is('android') || this.platform.is('ios')) {
      const info = await Device.getInfo();
      return {
        platform: this.platform.is('android') ? 'android' : 'ios',
        osVersion: info.osVersion,
        model: info.model,
        manufacturer: info.manufacturer
      };
    }
    return {
      platform: 'web',
      osVersion: 'unknown',
      model: 'unknown',
      manufacturer: 'unknown'
    };
  }
}